import React from 'react'
import IncidentPerAttribute from './IncidentPerAttribute'


const ValidIncidentsPerRight
 = () => {

    const monitorReport = false;

    return (
        <>
            <IncidentPerAttribute monitorReport={monitorReport} attributeType ="RIGHT" disaggregation = "sex"/>
        </>
    
  )
}

export default ValidIncidentsPerRight
